import React from 'react';
import styles from './SideBar.module.scss';
import clsx from 'clsx';
import OutsideClickHandler from 'react-outside-click-handler';

const SideBar = ({ show, onClose, children, width = 480, direction = 'right', className }) => {
  return (
    <>
      <div className={clsx(styles.sidebar, show && styles.sidebarActive, direction == 'right' && styles.sidebarRight, direction == 'left' && styles.sidebarLeft)} style={{ width: `${width}px` }}>
        {' '}
        <OutsideClickHandler onOutsideClick={onClose}>
          <div className={clsx(styles.content, className)}> {children} </div>
        </OutsideClickHandler>
      </div>
    </>
  );
};

export default SideBar;
